import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';

export interface BrandingAsset {
  url: string;
  content_type: string;
  updated_at: string;
}

export interface BrandingResponse {
  device_uuid: string;
  tenant_logo_qr: BrandingAsset | null;
}

@Injectable({
  providedIn: 'root',
})
export class BrandingService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.speaksee.apiUrl}/v1/branding/device`;
  private readonly cache = new Map<string, Observable<BrandingResponse>>();

  getBranding(deviceUuid: string): Observable<BrandingResponse> {
    const cached = this.cache.get(deviceUuid);
    if (cached) {
      return cached;
    }
    const request = this.http
      .get<BrandingResponse>(`${this.baseUrl}/${deviceUuid}`)
      .pipe(shareReplay(1));
    this.cache.set(deviceUuid, request);
    return request;
  }

  clear(deviceUuid: string): void {
    this.cache.delete(deviceUuid);
  }
}
